import React from 'react';
import { Route, Link } from "react-router-dom";
import { default as Menu } from 'react-burger-menu/lib/menus/push';



// as per https://reacttraining.com/react-router/web/example/custom-link
const CbMenuLink = ({ label, to, activeOnlyWhenExact, onclick }) => (
    <Route
        path={to}
        exact={activeOnlyWhenExact}
        children={({ match }) => (
            <li className={match ? "active" : ""} onClick={ onclick }>
              <Link to={to}>{label}</Link>
            </li>
        )}
    />
);

class CbMobileNav extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      menuOpen: false
    }
  }

  // This keeps your state in sync with the opening/closing of the menu
  // via the default means, e.g. clicking the X, pressing the ESC key etc.
  handleStateChange (state) {
    this.setState({menuOpen: state.isOpen})
  }

  // This can be used to close the menu, e.g. when a user clicks a menu item
  closeMenu () {
    this.setState({menuOpen: false})
  }

  // This can be used to toggle the menu, e.g. when using a custom icon
  // Tip: You probably want to hide either/both default icons if using a custom icon
  // See https://github.com/negomi/react-burger-menu#custom-icons
  toggleMenu () {
    this.setState({menuOpen: !this.state.menuOpen})
  }

  render () {

    return (
        <Menu right
              width={ '200px' }
              customBurgerIcon={ <img src={process.env.PUBLIC_URL + "/img/cbr_mobilemenu_white.png"} alt={"Burger icon"}/> }
              isOpen={this.state.menuOpen}
              onStateChange={(state) => this.handleStateChange(state)}
              pageWrapId={ "page-wrap" }
              outerContainerId={ "outer-container" }>

          <CbMenuLink to="/work" label="work" onclick={ () => this.closeMenu() } />
          <CbMenuLink to="/about" label="about" onclick={ () => this.closeMenu() } />
          <CbMenuLink to="/contact" label="contact" onclick={ () => this.closeMenu() } />

        </Menu>
    );
  }
}


const CbNavigationLinks = () => (
    <ul>
      {/*<CbMenuLink activeOnlyWhenExact={true} to="/work" label="work" />*/}
      <CbMenuLink to="/work" label="work" />
      <CbMenuLink to="/about" label="about" />
      <CbMenuLink to="/contact" label="contact" />
    </ul>
)


const CbNavigation = ({ match }) => {

  const izHome = (typeof match.params.id === "undefined");

  if (izHome) {
    return (
        <nav className="cb-navigation cb-nav-home">
          <section className="container">
            <CbNavigationLinks />
          </section>
        </nav>
    )
  } else {
    return (
        <nav className="cb-navigation cb-normalnav">
          <section className="container">

            <div className={"cb-tile"}>
              <Link to="/" className="cb-navlogo">
                <img src={process.env.PUBLIC_URL + "/img/cbr_logo.svg"} alt={"Christoph Breitbach Logo"}/>
              </Link>
            </div>

            <div className={"cb-tile"}>
              <CbNavigationLinks />
            </div>

          </section>
        </nav>
    )
  }


}

export { CbNavigation, CbMobileNav };


// WEBPACK FOOTER //
// ./src/includes/Navigation.jsx